// extracted by mini-css-extract-plugin
module.exports = {"root":"product-description_root__xMFX3","title":"product-description_title__344_y","button":"product-description_button__1wXnR"};